import { render, staticRenderFns } from "./Seed.vue?vue&type=template&id=70fb8b40&scoped=true&"
import script from "./Seed.vue?vue&type=script&lang=js&"
export * from "./Seed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fb8b40",
  null
  
)

export default component.exports